module.exports = __webpack_public_path__ + "img/port-everglades-emergency-power-study-1.bb225e5f.png";